import React, {forwardRef, useContext} from 'react';
import {SharedContext} from "../../Pages";
import PrinterHeader from "./Print/PrinterHeader";
import PrinterBody from "./Print/PrinterBody";
import PrinterFooter from "./Print/PrinterFooter";

const PrintDataComponent = forwardRef((props, ref) => {

  const {sharedDataState,widthHeightSizeFromSizeTitle} = props;
  console.log(widthHeightSizeFromSizeTitle)
  if (sharedDataState?.type === "print") {
//     const style = `
//
//     .printer{
//       transition: all 0.5s;
//       background-color:red;
//       width:${widthHeightSizeFromSizeTitle.width};
//       height:${widthHeightSizeFromSizeTitle.height};
//     }
//     @page {
//       size: ${widthHeightSizeFromSizeTitle.size};
//       margin: 0;
// }
//
//     `;

    const style = ``;
    return (
      <>
        <style>{style}</style>
        <div className={"printer"} ref={ref}>
          123
          <PrinterHeader sharedDataState={sharedDataState}/>
          <PrinterBody sharedDataState={sharedDataState}/>
          <PrinterFooter sharedDataState={sharedDataState}/>
        </div>
      </>
    );
  } else {
    return (
      <div ref={ref}
           className={"d-flex justify-content-center align-content-center"}
           style={{height: "80vh"}}
      >
        چیزی برای پرینت نیست
      </div>
    );
  }
})

export default PrintDataComponent;
